var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    style: {
      enableBackground: "new 0 0 100 125"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 50,
    cy: 25.8,
    rx: 32.1,
    ry: 10.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,43.5c-11.6,0-24.4-1.9-32.1-6.8v13.5c0,6,14.4,10.8,32.1,10.8s32.1-4.8,32.1-10.8V36.7 C74.4,41.6,61.6,43.5,50,43.5z M68.2,53.6c-1.7,0-3-1.4-3-3.1s1.4-3.1,3-3.1c1.7,0,3.1,1.4,3.1,3.1S69.9,53.6,68.2,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.9,61.2v13.5c0,6,14.4,10.9,32.1,10.9s32.1-4.9,32.1-10.9V61.2C74.5,66.1,61.6,68,50,68S25.6,66,17.9,61.2 z M68.2,72c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1s-3-1.4-3-3.1C65.2,73.3,66.6,72,68.2,72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.9,85.7v13.5c0,6,14.4,10.8,32.1,10.8s32.1-4.8,32.1-10.8V85.7c-7.7,4.8-20.5,6.8-32.1,6.8 S25.6,90.5,17.9,85.7z M68.2,96.4c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1s-3-1.4-3-3.1S66.6,96.4,68.2,96.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.a594cc33e488f770883b63fdeebdbc6d.svg";
export { ForwardRef as ReactComponent };